import { TextField, Tooltip } from '@mui/material';
import { forwardRef } from 'react';

export const DatePickerInput = forwardRef((props, ref) => (
  <Tooltip placement='bottom' title={props?.tooltip || ''} >
    <TextField {...props} ref={ref} />
  </Tooltip>
));
